/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "rãketá",
      "-2": "rãké ũn tá",
      "0": "uri",
      "1": "vajkỹ",
      "2": "vaj ũn ka",
      "future": {
        "other": "kurã {0} kar kỹ"
      },
      "past": {
        "other": "kurã {0} si ser"
      }
    },
    "day-narrow": {
      "-1": "rãketá",
      "-2": "rãké ũn tá",
      "0": "uri",
      "1": "vajkỹ",
      "2": "vaj ũn ka",
      "future": {
        "other": "kurã {0} kar kỹ"
      },
      "past": {
        "other": "kurã {0} si ser"
      }
    },
    "day-short": {
      "-1": "rãketá",
      "-2": "rãké ũn tá",
      "0": "uri",
      "1": "vajkỹ",
      "2": "vaj ũn ka",
      "future": {
        "other": "kurã {0} kar kỹ"
      },
      "past": {
        "other": "kurã {0} si ser"
      }
    },
    "hour": {
      "0": "óra tag kã",
      "future": {
        "other": "óra {0} kar kỹ"
      },
      "past": {
        "other": "óra {0} si ser"
      }
    },
    "hour-narrow": {
      "0": "óra tag kã",
      "future": {
        "one": "{0} h kar kỹ",
        "other": "{0} h kar kỹ"
      },
      "past": {
        "one": "{0} h si ser",
        "other": "{0} h si ser"
      }
    },
    "hour-short": {
      "0": "óra tag kã",
      "future": {
        "one": "{0} h kar kỹ",
        "other": "{0} h kar kỹ"
      },
      "past": {
        "one": "{0} h si ser",
        "other": "{0} h si ser"
      }
    },
    "minute": {
      "0": "mĩnũtu tag",
      "future": {
        "other": "mĩnũtu {0} kar kỹ"
      },
      "past": {
        "other": "mĩnũtu {0} si ser"
      }
    },
    "minute-narrow": {
      "0": "mĩnũtu tag",
      "future": {
        "one": "mĩn. {0} kar kỹ",
        "other": "mĩn. {0} kar kỹ"
      },
      "past": {
        "one": "mĩn. {0} si ser",
        "other": "mĩn. {0} si ser"
      }
    },
    "minute-short": {
      "0": "mĩnũtu tag",
      "future": {
        "one": "mĩn. {0} kar kỹ",
        "other": "mĩn. {0} kar kỹ"
      },
      "past": {
        "one": "mĩn. {0} si ser",
        "other": "mĩn. {0} si ser"
      }
    },
    "month": {
      "-1": "kysã tĩ mũn kã",
      "0": "kysã tag kã",
      "1": "kysã ũn kã",
      "future": {
        "other": "kysã {0} kar kỹ"
      },
      "past": {
        "other": "kysã {0} si ser"
      }
    },
    "month-narrow": {
      "-1": "kysã tĩ mũn kã",
      "0": "kysã tag kã",
      "1": "kysã ũn kã",
      "future": {
        "other": "kysã {0} kar kỹ"
      },
      "past": {
        "other": "kysã {0} si ser"
      }
    },
    "month-short": {
      "-1": "kysã tĩ mũn kã",
      "0": "kysã tag kã",
      "1": "kysã ũn kã",
      "future": {
        "other": "kysã {0} kar kỹ"
      },
      "past": {
        "other": "kysã {0} si ser"
      }
    },
    "nu": [
      "latn"
    ],
    "quarter": {
      "-1": "kysã tẽgtũ ẽg no",
      "0": "kysã tẽgtũ tag",
      "1": "kysã tẽgtũ ũn kã",
      "future": {
        "other": "kysã-tẽgtũ {0} kar kỹ"
      },
      "past": {
        "other": "kysã-tẽgtũ {0} si ser"
      }
    },
    "quarter-narrow": {
      "-1": "kysã tẽgtũ ẽg no",
      "0": "kysã tẽgtũ tag",
      "1": "kysã tẽgtũ ũn kã",
      "future": {
        "other": "kysã-tẽgtũ {0} kar kỹ"
      },
      "past": {
        "other": "kysã-tẽgtũ {0} si ser"
      }
    },
    "quarter-short": {
      "-1": "kysã tẽgtũ ẽg no",
      "0": "kysã tẽgtũ tag",
      "1": "kysã tẽgtũ ũn kã",
      "future": {
        "other": "kysã-tẽgtũ {0} kar kỹ"
      },
      "past": {
        "other": "kysã-tẽgtũ {0} si ser"
      }
    },
    "second": {
      "0": "ha",
      "future": {
        "other": "segũno {0} kar kỹ"
      },
      "past": {
        "other": "segũno {0} si ser"
      }
    },
    "second-narrow": {
      "0": "ha",
      "future": {
        "one": "seg. {0} kar kỹ",
        "other": "seg. {0} kar kỹ"
      },
      "past": {
        "one": "seg. {0} si ser",
        "other": "seg. {0} si ser"
      }
    },
    "second-short": {
      "0": "ha",
      "future": {
        "one": "seg. {0} kar kỹ",
        "other": "seg. {0} kar kỹ"
      },
      "past": {
        "one": "seg. {0} si ser",
        "other": "seg. {0} si ser"
      }
    },
    "week": {
      "-1": "simỹnỹ tĩ mũn kã",
      "0": "simỹnỹ tag kã",
      "1": "simỹnỹ ũn kã",
      "future": {
        "other": "simỹnỹ {0} kar kỹ"
      },
      "past": {
        "other": "simỹnỹ {0} si ser"
      }
    },
    "week-narrow": {
      "-1": "simỹnỹ tĩ mũn kã",
      "0": "simỹnỹ tag kã",
      "1": "simỹnỹ ũn kã",
      "future": {
        "one": "sim. {0} kar kỹ",
        "other": "sim. {0} kar kỹ"
      },
      "past": {
        "one": "sim. {0} si ser",
        "other": "sim. {0} si ser"
      }
    },
    "week-short": {
      "-1": "simỹnỹ tĩ mũn kã",
      "0": "simỹnỹ tag kã",
      "1": "simỹnỹ ũn kã",
      "future": {
        "one": "sim. {0} kar kỹ",
        "other": "sim. {0} kar kỹ"
      },
      "past": {
        "one": "sim. {0} si ser",
        "other": "sim. {0} si ser"
      }
    },
    "year": {
      "-1": "prỹg tĩ mũnh kã",
      "0": "prỹg tag kã",
      "1": "prỹg ũ kã",
      "future": {
        "other": "prỹg {0} kar kỹ"
      },
      "past": {
        "other": "prỹg {0} si ser"
      }
    },
    "year-narrow": {
      "-1": "prỹg tĩ mũnh kã",
      "0": "prỹg tag kã",
      "1": "prỹg ũ kã",
      "future": {
        "other": "prỹg {0} kar kỹ"
      },
      "past": {
        "other": "prỹg {0} si ser"
      }
    },
    "year-short": {
      "-1": "prỹg tĩ mũnh kã",
      "0": "prỹg tag kã",
      "1": "prỹg ũ kã",
      "future": {
        "other": "prỹg {0} kar kỹ"
      },
      "past": {
        "other": "prỹg {0} si ser"
      }
    }
  },
  "locale": "kgp"
})
}
